import actions from "~/shared/actions";
import * as server from "~/shared/api/server";

export const loadUtbetalingsoversikt = (policyNumber) => (dispatch) => {
	dispatch(actions.getUtbetalingsoversiktRequest({ policyNumber }));

	return server.getUtbetalingsoversikt(policyNumber).then((utbetalingsoversikt) => dispatch(actions.getUtbetalingsoversiktResponse({ policyNumber, utbetalingsoversikt })));
};

export const loadNjordUtbetalingsoversikt = (policyNumber) => (dispatch) => {
	dispatch(actions.getNjordUtbetalingsoversiktRequest({ policyNumber }));

	return server.getNjordUtbetalingsoversikt(policyNumber).then((utbetalingsoversikt) => dispatch(actions.getNjordUtbetalingsoversiktResponse({ policyNumber, utbetalingsoversikt })));
};
